import { AfterViewInit, DestroyRef, Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ResizeObserverFactory } from '../service/resize-observer.factory';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[fixedHeader]',
})
export class FixedHeaderDirective implements OnInit, AfterViewInit {
  @Input() virtual: boolean = false;

  private headerEl?: HTMLElement;
  private tableEl?: HTMLElement;
  private scrollContentEl?: HTMLElement;

  constructor(
    private elRef: ElementRef,
    private resizeObserverService: ResizeObserverFactory,
    private destroyRef: DestroyRef,
  ) {
  }

  ngOnInit(): void {
    const el = this.elRef.nativeElement;
    const children = el.nextSibling.children;
    if (this.virtual) {
      this.scrollContentEl = children[children.length - 1];
      this.tableEl = this.scrollContentEl?.children[0] as HTMLElement;
    } else {
      this.tableEl = children[0];
      this.scrollContentEl = this.tableEl;
    }
    el.style.opacity = '0';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.headerEl = this.elRef?.nativeElement;
      if (this.headerEl && this.tableEl && this.scrollContentEl) {
        this.headerEl.style.width = `${this.tableEl.clientWidth}px`;
        this.headerEl.style.zIndex = '10';
        this.headerEl.style.position = 'relative';
        this.headerEl.style.opacity = '1';
        this.updateTableOffset();
        this.resizeObserverService.create(this.scrollContentEl).pipe(
          takeUntilDestroyed(this.destroyRef),
          debounceTime(100)
        ).subscribe((size) => this.updateHeaderWidth(size));
        this.resizeObserverService.create(this.headerEl).pipe(
          takeUntilDestroyed(this.destroyRef),
          debounceTime(100)
        ).subscribe((_size) => this.updateTableOffset());
      }
    });
  }

  private updateTableOffset(): void {
    if (this.tableEl && this.headerEl) {
      this.tableEl.style.marginTop = `${this.headerEl.clientHeight}px`;
      this.headerEl.style.marginBottom = `-${this.headerEl.clientHeight}px`;
    }
  }

  private updateHeaderWidth(size: { width: number, height: number }): void {
    if (this.headerEl) {
      this.headerEl.style.width = `${size.width}px`
    }
  }
}
